import { DeployedAsTypeNames, listingTypeOptions } from "../constants/listingTypes";
import type { ProductListing } from "../types/generated-graphql";

export const getProductTypeNameWithDistributedBy = (product: ProductListing) => {
	const deployedAsType = product?.deployed_as
		? `${
				product?.deployed_as
					.map((item) => (item ? (DeployedAsTypeNames as Record<string, string>)[item] || null : null))
					.filter((item) => item)
					.sort()
					.join(", ") || ""
			}` || null
		: null;
	let typeName = listingTypeOptions.find((option) => product?.type && option.value === product?.type)?.header || "";
	typeName = typeName + (deployedAsType ? ` (${deployedAsType})` : "");
	return typeName;
};
